import type { CreateLineItemRequestPayload, CreateLineItemResponse } from '@vy/api-definition';
import { CreateLineItemResponseSchema } from '@vy/api-definition';
import type { UseMutationOptions } from 'react-query';
import { useMutation, useQueryClient } from 'react-query';
import { getPrivateApi } from '../../services/api';
import { queryKeys } from '../../services/query-key/query-keys';
import { invalidateInvoicesQueries } from '../../utils/query-invalidation';

export function useCreateLineItem(
  options?: UseMutationOptions<CreateLineItemResponse, unknown, CreateLineItemRequestPayload>,
) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (createLineItemRequest) => {
      const api = getPrivateApi();
      const createLineItemResponse = await api.createLineItem({
        createLineItemRequest: {
          ...createLineItemRequest,
          percentage: createLineItemRequest.percentage ?? null,
        },
      });

      const lineItemResponse = CreateLineItemResponseSchema.parse(createLineItemResponse);
      await queryClient.invalidateQueries(queryKeys.dynamicInvoice(createLineItemRequest.invoiceId));

      return lineItemResponse;
    },
    onSuccess: async () => {
      await Promise.all([invalidateInvoicesQueries(queryClient)]);
    },
    ...options,
  });
}
